import actions from "@/store/client/actions";
import mutations from "@/store/client/mutations";
import state from "@/store/client/state";
export default {
    actions,
    mutations,
    state
}